"use client";

export default function Error({ reset }) {
  return (
    <div className="container content-page text-center">
      <h1>Something went wrong</h1>
      <p>We could not load this page correctly.</p>
      <button type="button" className="btn btn-primary" onClick={() => reset()}>
        Try again
      </button>
    </div>
  );
}
